// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/GestaoClientes_CarregaClientesSemOrcamentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /gestao_clientes/carrega_clientes_sem_orcamento
 *
 * Returns array of cliente records that have no orcamentos. Backed by
 * Clientes_model::clientes_sem_orcamento() (thinner projection than
 * dadosXcrud — see Row class). Controller enriches each row with
 * `ocorrencias` (from occurrences-service) and `ultimaOcorrencia` (a
 * formatted summary string).
 */
import type { GestaoClientes_CarregaClientesSemOrcamentoRow } from './GestaoClientes_CarregaClientesSemOrcamentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type GestaoClientes_CarregaClientesSemOrcamentoResponseDados = GestaoClientes_CarregaClientesSemOrcamentoRow[];

export type GestaoClientes_CarregaClientesSemOrcamentoResponse = ApiResponse<GestaoClientes_CarregaClientesSemOrcamentoResponseDados>;

registerResponseContract('GestaoClientes_CarregaClientesSemOrcamentoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      cliente_id:            { type: 'number',  required: true },
      acoes:                 { type: 'number',  required: true },
      nome:                  { type: 'string',  required: true },
      documento:             { type: 'string',  required: false },
      franquia_id:           { type: 'number',  required: true },
      ddi:                   { type: 'string',  required: false },
      ddd:                   { type: 'string',  required: false },
      telefone:              { type: 'string',  required: false },
      rua:                   { type: 'string',  required: false },
      cep:                   { type: 'string',  required: false },
      numero:                { type: 'string',  required: false },
      complemento:           { type: 'string',  required: false },
      bairro:                { type: 'string',  required: false },
      cliente_location_id:   { type: 'number',  required: false },
      cliente_location_type: { type: 'string',  required: false },
      data_cadastro:         { type: 'string',  required: false },
      status:                { type: 'number',  required: false },
      franquia:              { type: 'string',  required: false },
      localidade:            { type: 'string',  required: false },
      ocorrencias: {
        type: 'array',
        required: false,
        items: {
          ID:        { type: 'string',  required: false },
          CreatedAt: { type: 'string',  required: false },
          UpdatedAt: { type: 'string',  required: false },
          DeletedAt: { type: 'string',  required: false },
          Owner:     { type: 'string',  required: false },
          OwnerID:   { type: 'number',  required: false },
          User:      { type: 'string',  required: false },
          Content:   { type: 'string',  required: false },
          user_id:   { type: 'string',  required: false },
          tenant_id: { type: 'string',  required: false },
        },
      },
      ultimaOcorrencia:      { type: 'string',  required: false },
    },
  },
})
